import { render, staticRenderFns } from "./ReviewMemberAssignmentSetting.vue?vue&type=template&id=438a8658&scoped=true&"
import script from "./ReviewMemberAssignmentSetting.vue?vue&type=script&lang=js&"
export * from "./ReviewMemberAssignmentSetting.vue?vue&type=script&lang=js&"
import style0 from "./ReviewMemberAssignmentSetting.vue?vue&type=style&index=0&id=438a8658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438a8658",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VIcon,VSwitch})
